<template>
    <div class="" >
        <uploader :autoStart="true" :ref="'doc_uploader'" :options="renderUploadOptions()" class="uploader-example">
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop>
                <span>Drop files here to upload or </span>
                <uploader-btn>select files</uploader-btn>
                <!--<b-row>
                    <b-col cols="7">
                        <p style="margin-top: 5px ;margin-bottom: 0;">Drop files here to upload or</p>
                    </b-col>
                    <b-col cols="5">
                        <uploader-btn style="margin-bottom: 0;">Select file</uploader-btn>
                    </b-col>
                </b-row>-->
                
                
            </uploader-drop>
            <uploader-list></uploader-list>
        </uploader>
    </div>
</template>

<script>
export default {
    props:{
        type:{
            required: true,
        },
        user_id:{
            required: true,
        }
    },
    data:() => ({
        
    }),
    computed:{},
    methods:{
        renderUploadOptions() {
            var storage = window.localStorage;
            var AUTH_TOKEN = storage.getItem('x_token');
            var url = process.env.VUE_APP_API_BASEURL + 'api/clientadmin/uploadpersonneldoc';
            var options = {
                target: url,
                query: {
                    user_id: this.user_id,
                    doc_type: this.type,
                },
                headers: {
                    'Access-Control-Allow-Credentials': true,
                    'X-Requested-With': 'XMLHttpRequest',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                testChunks: false,
                fileParameterName: 'personnel_doc', //Set the upload post param which will contain the binary payload
                singleFile: true, //Limit upload to one file
            }
            return options;
        },
    },
    mounted(){
        const uploaderInstance = this.$refs['doc_uploader'];
        const upload = uploaderInstance.uploader;
        upload.on('complete', ()=>{
            this.$emit('fileSuccess');
            upload.cancel();
        });
    },
}
</script>

<style>
.uploader-example {
    /*width: 880px;*/
    /*padding: 15px;
    margin: 40px auto 0;*/
    font-size: 12px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4);
}
.uploader-example .uploader-btn {
    margin-right: 4px;
    margin-bottom: 0px;
}
.uploader-example .uploader-list {
    max-height: 440px;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
}
</style>